import Contador from "./Contador";
import JueguitoGuls from "./JueguitoGuls";
import PreguntaTres from "./PreguntaTres";
import SpaceInvaders from "./SpaceInvaders";
import Pokemon from "./PokeDex/index";
import Pelotita from "./Pelotita";
import RickMorty from "./RickMorty";
import FormularioContexto from "./FormularioContexto";
import RunicMemorise from "./RunicMemorise/index";
import Builds from "./Builds/Builds";
import Ahorcado from "./Ahorcado";
import Minesweeper from "./Minesweeper";

const Examples = [
  Minesweeper,
  Contador,
  PreguntaTres,
  JueguitoGuls,
  SpaceInvaders,
  Pelotita,
  Pokemon,
  RickMorty,
  FormularioContexto,
  RunicMemorise,
  Builds,
  Ahorcado
];

export default Examples;
